import React from 'react';
import './SupportNavigation.css';

const SupportNavigation = ({ activeSection, setActiveSection }) => {
  const navigationItems = [
    {
      id: 'report',
      label: 'Submit a Report',
      icon: 'fa-solid fa-pen-to-square'
    },
    {
      id: 'my-reports',
      label: 'My Reports',
      icon: 'fa-solid fa-clipboard-list'
    },
    {
      id: 'faq',
      label: 'FAQ',
      icon: 'fa-solid fa-circle-question'
    }
  ];

  return (
    <nav className="support-navigation">
      <ul>
        {navigationItems.map(item => (
          <li key={item.id}>
            <button
              className={`nav-item ${activeSection === item.id ? 'active' : ''}`}
              onClick={() => setActiveSection(item.id)}
            >
              <i className={item.icon}></i>
              <span>{item.label}</span>
            </button>
          </li>
        ))}
      </ul>
    </nav>
  );
};

export default SupportNavigation;